import React from "react";

export default function SearchBar({
  filters,
  onChange,
  onSearch,
  loading,
}) {
  const hasSearchData = [filters.plate, filters.cpfCnpj, filters.clientName].some(
    (value) => (value || "").trim() !== ""
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!hasSearchData) return;
    onSearch();
  };

  return (
    <div className="card mb-3">
      <div className="card-body">
        <h4 className="card-title mb-3 fw-bold">Busca do veículo</h4>

        <form className="container-fluid p-0" onSubmit={handleSubmit}>
          <div className="row g-2 align-items-end">
            <div className="col-md-3">
              <label className="form-label">Placa</label>
              <input
                type="text"
                className="form-control"
                placeholder="Ex: ABC1D23"
                value={filters.plate}
                onChange={(e) => onChange("plate", e.target.value.toUpperCase())}
              />
            </div>

            <div className="col-md-3">
              <label className="form-label">CPF/CNPJ</label>
              <input
                type="text"
                className="form-control"
                placeholder="Digite CPF ou CNPJ"
                value={filters.cpfCnpj}
                onChange={(e) => onChange("cpfCnpj", e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Nome do cliente</label>
              <input
                type="text"
                className="form-control"
                placeholder="Digite o nome"
                value={filters.clientName}
                onChange={(e) => onChange("clientName", e.target.value)}
              />
            </div>

            <div className="col-md-2 d-grid">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading || !hasSearchData}
              >
                {loading ? (
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                ) : null}
                BUSCAR
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
